/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/skusMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Skus. */
var Skus = /** @class */function () {
  /**
   * Create a Skus.
   * @param {LabServicesClientContext} client Reference to the service client.
   */
  function Skus(client) {
    this.client = client;
  }
  Skus.prototype.list = function (options, callback) {
    return this.client.sendOperationRequest({
      options: options
    }, listOperationSpec, callback);
  };
  Skus.prototype.listNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listNextOperationSpec, callback);
  };
  return Skus;
}();
export { Skus };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/providers/Microsoft.LabServices/skus",
  urlParameters: [Parameters.subscriptionId],
  queryParameters: [Parameters.apiVersion, Parameters.filter],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedLabServicesSkus
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://management.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedLabServicesSkus
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};